import React from 'react';


import FormElement from '../index';
import FormFieldError from '../../FormFieldError';
import Textarea from '../../Textarea/Textarea';


function FormTextarea(props) {

    return (
        <FormElement
            {...props}
        >

            <Textarea
                {...props}
            />

            <FormFieldError error={props.error}/>

        </FormElement>
    );
}


FormTextarea.propTypes = {
    ...FormElement.propTypes,
    ...Textarea.propTypes
};

FormTextarea.defaultProps = {
    ...FormElement.defaultProps,
    ...Textarea.defaultProps
};


export default FormTextarea;
